<div class="admin-stats-dashboard flex h-full min-h-0 w-full flex-col overflow-hidden">
  <div class="shrink-0 p-5">
    <div class="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h4 class="m-0 text-3xl font-bold tracking-tight text-zinc-900 dark:text-white">Reports</h4>
        @if (rangeLabel) {
          <p class="m-0 mt-2 max-w-4xl text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
            Platform activity for {{ rangeLabel }}
            @if (metrics) {
              · {{ metrics.days }} days
            }
            @if (previousRangeLabel) {
              · compared with {{ previousRangeLabel }}
            }
          </p>
        } @else {
          <p class="m-0 mt-2 max-w-4xl text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
            Generate quarterly and custom period reports for business review.
          </p>
        }
      </div>

      <button
        type="button"
        class="inline-flex shrink-0 items-center justify-center rounded-lg bg-violet-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-violet-500 disabled:cursor-not-allowed disabled:opacity-50"
        [disabled]="loadingState !== 'loaded' || !metrics || savingState === 'saving'"
        (click)="saveReport()"
      >
        @if (savingState === 'saving') {
          Saving…
        } @else {
          Save report
        }
      </button>
    </div>
  </div>

  <admin-reports-period-filter (periodChange)="onPeriodChange($event)" />

  @if (loadingState === 'error' && error) {
    <div
      class="mx-5 mt-4 shrink-0 rounded-xl border border-rose-200 bg-rose-50 p-3 dark:border-rose-500/30 dark:bg-rose-500/10"
    >
      <p class="m-0 text-sm text-rose-700 dark:text-rose-300">{{ error }}</p>
    </div>
  }

  <div class="flex min-h-0 flex-1 flex-col gap-5 overflow-auto px-5 pb-5 scrollbar-transparent">
    @if (loadingState === 'loading') {
      <atom-loading-inline title="Loading report" message="Fetching period metrics…" />
    } @else if (metrics) {
      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        @for (card of kpiCards; track card.key) {
          <section class="admin-stats-panel rounded-2xl p-5">
            <div class="flex items-center gap-2">
              <span class="size-2 rounded-full" [class]="kpiAccentDotClass(card.accent)" aria-hidden="true"></span>
              <p class="m-0 text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 dark:text-zinc-400">
                {{ card.label }}
              </p>
            </div>
            <p
              class="m-0 mt-4 text-4xl font-bold leading-none tabular-nums text-zinc-900 dark:text-white xl:text-5xl"
            >
              {{ card.current.toLocaleString() }}
            </p>
            @let trend = getKpiTrend(card.current, card.previous);
            <p class="m-0 mt-4 text-sm">
              <span class="font-semibold" [class]="trend.trendClass">{{ trend.arrow }} {{ trend.percentLabel }}</span>
              <span class="text-zinc-500 dark:text-zinc-500"> {{ trend.comparisonLabel }}</span>
            </p>
          </section>
        }
      </div>

      <section class="admin-stats-panel rounded-2xl p-5">
        <div class="mb-4 flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-2">
          <h5 class="m-0 text-base font-semibold text-zinc-900 dark:text-white">Period comparison</h5>
          <p class="m-0 text-xs font-medium uppercase tracking-[0.16em] text-zinc-500">
            Selected vs previous
          </p>
        </div>
        @if (comparisonChartHasData && comparisonChartOption) {
          <app-echart-generic-chart
            class="block h-72 w-full"
            [chartOption]="comparisonChartOption"
            [chartXaxisData]="comparisonChartXaxisData"
            [chartVariant]="comparisonChartVariant"
          />
        } @else {
          <div
            class="flex h-72 items-center justify-center rounded-xl border border-dashed border-zinc-200 dark:border-white/10"
          >
            <p class="m-0 text-sm text-zinc-500">No data for these periods yet.</p>
          </div>
        }
      </section>
    } @else if (loadingState === 'idle') {
      <div
        class="flex flex-1 items-center justify-center rounded-2xl border border-dashed border-zinc-200 dark:border-white/10"
      >
        <p class="m-0 text-sm text-zinc-500">Select a period to generate a report.</p>
      </div>
    }
  </div>
</div>
